import { IonButton, IonIcon } from '@ionic/react'
import { cloudOfflineOutline, refreshOutline } from 'ionicons/icons'

interface ServerErrorScreenProps {
  onRetry?: () => void
}

export const ServerErrorScreen: React.FC<ServerErrorScreenProps> = ({ onRetry }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-6 text-center bg-background">
      <IonIcon
        icon={cloudOfflineOutline}
        className="text-6xl text-muted-foreground mb-6"
      />
      <h1 className="text-2xl font-bold mb-3">
        No se puede conectar con el servidor
      </h1>
      <p className="text-muted-foreground mb-8 max-w-md">
        No hemos podido establecer conexión con el servidor.
        Por favor, verifica tu conexión a internet e inténtalo de nuevo.
      </p>
      {onRetry && (
        <IonButton
          onClick={onRetry}
          color="primary"
        >
          <IonIcon slot="start" icon={refreshOutline} />
          Reintentar
        </IonButton>
      )}
    </div>
  )
}
